import React, { useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { UserContext } from '../contexts/UserContext';

const MembershipSuccess = () => {
  const navigate = useNavigate();
  const { user, firestoreUser } = useContext(UserContext);

  useEffect(() => {
    // Auto-redirect to dashboard after 15 seconds
    const timer = setTimeout(() => {
      navigate('/dashboard');
    }, 15000);

    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <div style={{ backgroundColor: '#F7F3EB', minHeight: 'calc(100vh - var(--navbar-height, 125px))', display: 'flex', flexDirection: 'column' }}>
      <style>
        {`
          .membership-success-bg {
            background-color: #F7F3EB !important;
          }
        `}
      </style>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" style={{ paddingTop: '2rem', paddingBottom: '2rem', flex: '1', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <div className="max-w-md w-full">
          <div style={{ 
            backgroundColor: 'white', 
            borderRadius: '12px',
            boxShadow: '0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)', 
            padding: '2rem'
          }}>
            <div className="text-center">

              <h2 className="text-3xl font-extrabold text-gray-900 mb-4">
                🎉 Subscription Successful!
              </h2>
              
              <p className="text-lg text-gray-600 mb-6">
                Welcome to your new membership tier! Your account has been upgraded.
              </p>

              {/* Benefits Reminder */}
              <div style={{ 
                backgroundColor: '#F9FAFB', 
                border: '1px solid #E5E7EB', 
                borderRadius: '8px', 
                padding: '1.5rem', 
                marginBottom: '1.5rem',
                width: '65%',
                margin: '0 auto 1.5rem auto'
              }}>
                <h3 className="text-lg font-semibold text-gray-900 mb-4">Your Benefits:</h3>
                <div className="text-left text-sm text-gray-600 space-y-2">
                  <div>No $3 trade completion fees</div>
                  <div>Reduced 4% cash exchange fee</div>
                  <div>Access to premium features</div>
                </div>
              </div>

              {/* Auto-redirect notice */}
              <p className="text-xs text-gray-500 mt-4">
                You'll be automatically redirected to your dashboard in a few seconds...
              </p>

              {/* Processing Notice */}
              <div className="mt-6 p-4 bg-blue-50 rounded-lg">
                <p className="text-sm text-blue-800">
                  <strong>🔄 Processing:</strong> Your membership status will update automatically within a few moments. 
                  If you don't see changes immediately, try refreshing the page.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MembershipSuccess;